import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import CommonFormBuilder from "@/app/components/common-form-builder/CommonFormBuilder";
import Separator from "@/app/components/lib/Separator";
import React from "react";
import { UseFormReturn } from "react-hook-form";

type Props = {
  fields: IField[];
  form: UseFormReturn<any, any, undefined>;
};
const ProductOtherFields: React.FC<Props> = ({ fields, form }) => {
  return (
    <>
      {fields?.map((field) => (
        <div key={field?.configurations?.key}>
          <Separator
            marginBottom={8}
            startLabel={
              <>
                {field?.configurations?.title}
                {field.configurations.is_required && (
                  <strong className="text-danger"> * </strong>
                )}
              </>
            }
          />
          <CommonFormBuilder
            field={{
              ...field,
              configurations: {
                ...field.configurations,
                hideLabel: true,
              },
            }}
            form={form}
          />
        </div>
      ))}
    </>
  );
};

export default ProductOtherFields;
